import React from "react";

import benefit01 from "../img/benefits/img1.svg"
import benefit02 from "../img/benefits/img2.svg"
import benefit03 from "../img/benefits/img3.svg"
import benefit04 from "../img/benefits/img4.svg"
import benefit05 from "../img/benefits/img5.svg"
import benefit06 from "../img/benefits/img6.svg"

import ov1img from "../img/overlays/bene-ov-1.svg"
import ov2img from "../img/overlays/bene-ov-2.svg"
import ov3img from "../img/overlays/bene-ov-3.svg"
import ov4img from "../img/overlays/bene-ov-4.svg"
import ov5img from "../img/overlays/bene-ov-5.svg"
import ov6img from "../img/overlays/bene-ov-6.svg"
import ov7img from "../img/overlays/bene-ov-7.svg"

import "../style/benefits.css";

function Benefits() {
    return (
        <div className="benefits-container">
            <b className="title">Nossos Benefícios</b>
            <span>Com a Educação Socioemocional, crianças e jovens aprendem a dialogar, ouvir, se expressar, respeitar, cooperar e conviver com as diferenças. Uma nova realidade se constrói na escola, promovendo bem-estar, aprendizagem e desenvolvimento humano.</span>

            <div className="benefits-grid">
                <div className="benefit-card">
                    <img src={benefit01} alt="benefit-img" className="benefit-img" />
                    <b>Redução do índice de violência e bullying</b>
                </div>

                <div className="benefit-card">
                    <img src={benefit02} alt="benefit-img" className="benefit-img" />
                    <b>Melhoria do desempenho acadêmico</b>
                </div>

                <div className="benefit-card">
                    <img src={benefit03} alt="benefit-img" className="benefit-img" />
                    <b>Prevenção da ansiedade e da depressão</b>
                </div>

                <div className="benefit-card">
                    <img src={benefit04} alt="benefit-img" className="benefit-img" />
                    <b>Estímulo a escolhas responsáveis</b>
                </div>

                <div className="benefit-card">
                    <img src={benefit05} alt="benefit-img" className="benefit-img" />
                    <b>Fortalecimento do trabalho em equipe</b>
                </div>

                <div className="benefit-card">
                    <img src={benefit06} alt="benefit-img" className="benefit-img" />
                    <b>Superação de desafios pessoais e sociais</b>
                </div>
            </div>

            <a href="#" className="link orange">
                <svg width="500" height="60" viewBox="0 0 656 65" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                    <path d="M632.232 59.0726C429.546 66.4161 226.336 66.4161 23.6495 59.0726C14.1777 58.7125 4.16343 53.9212 2.48978 48.488C-0.829927 37.6163 -0.829927 26.9639 2.48978 16.0922C4.16343 10.659 14.1777 5.87294 23.6495 5.5076C226.336 -1.83587 429.546 -1.83587 632.232 5.5076C641.703 5.86772 651.718 10.659 653.391 16.0922C656.711 26.9639 656.711 37.6163 653.391 48.488C651.718 53.9212 641.703 58.7072 632.232 59.0726Z" fill="#FF6C02"/>
                </svg>

                <b>Benefícios da Educação Socioemocional</b>
            </a>

            <a href="#" className="link blue">
                <svg width="300" viewBox="0 0 442 65" fill="none" xmlns="http://www.w3.org/2000/svg" className="bg">
                    <path d="M425.165 59.0726C288.862 66.4161 152.207 66.4161 15.9039 59.0726C9.53428 58.7125 2.79983 53.9212 1.67434 48.488C-0.558112 37.6163 -0.558112 26.9639 1.67434 16.0922C2.79983 10.659 9.53428 5.87294 15.9039 5.5076C152.207 -1.83587 288.862 -1.83587 425.165 5.5076C431.535 5.86772 438.269 10.659 439.395 16.0922C441.627 26.9639 441.627 37.6163 439.395 48.488C438.269 53.9212 431.535 58.7072 425.165 59.0726Z" fill="#3498D4"/>
                </svg>

                <b>Veja evidências e pesquisas</b>
                <svg width="25" height="17" viewBox="0 0 25 17" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow">
                    <path d="M15.2134 15.9338C14.731 15.4515 14.731 14.6722 15.2134 14.1899L20 9.37848H1.23686C0.556585 9.37848 -1.90735e-06 8.8219 -1.90735e-06 8.14162C-1.90735e-06 7.46135 0.556585 6.90477 1.23686 6.90477H20L15.201 2.10575C14.7186 1.62338 14.7186 0.844156 15.201 0.361781C15.6834 -0.120594 16.4626 -0.120594 16.945 0.361781L23.8714 7.27582C24.3537 7.7582 24.3537 8.53742 23.8714 9.01979L16.9573 15.9338C16.475 16.4038 15.6834 16.4038 15.2134 15.9338Z" fill="white"/>
                </svg>
            </a>

            <img src={ov1img} className="ov ov1" />
            <img src={ov2img} className="ov ov2" />
            <img src={ov3img} className="ov ov3" />
            <img src={ov4img} className="ov ov4" />
            <img src={ov5img} className="ov ov5" />
            <img src={ov6img} className="ov ov6" />
            <img src={ov7img} className="ov ov7" />
        </div>
    )
}

export default Benefits